import { useCallback } from "react";

import type { CashDrawerTrigger } from "~/api/logs/requests";
import { useAppDispatch } from "~/providers/app";

import { useSendWebEvent } from "./useSendWebEvent";

export const useOpenCashDrawer = () => {
  const dispatch = useAppDispatch();
  const sendWebEvent = useSendWebEvent();

  return useCallback(
    (trigger: CashDrawerTrigger) => {
      dispatch({ type: "CASH_DRAWER_OPEN_TRIGGER", payload: { trigger } });
      sendWebEvent({ type: "CASH_DRAWER_OPEN_REQUEST" });
    },
    [dispatch, sendWebEvent]
  );
};
